<template lang="pug">
  v-dialog(v-model='dialog' persistent max-width='1000px')
    v-card(grid-list-md)
      v-toolbar(dark, color='primary')
        v-toolbar-title {{ $t('pageHeader.newTicket') }}
      v-card-text(v-if="Ticket")
        v-container(grid-list-lg)
          v-layout(row wrap)
            v-flex(xs12)
              div Contact Information
              v-layout(row wrap) 
                v-flex(xs12 sm4)
                  v-text-field(v-model="Ticket.name" :error-messages="contactNameErrors" label='Contact Person*')
                v-flex(xs12 sm4)
                  v-text-field(v-model="Ticket.phoneNumber" label='Phone Number' :error-messages="phoneNumberErrors")
                v-flex(xs12 sm4)
                  v-text-field(v-model="Ticket.email" label='Email Address' :error-messages="emailAddressErrors")
            v-flex(xs12)
              div Source
              v-layout(row wrap) 
                v-flex(xs12 sm3)
                  v-select(
                    :items="comboBoxByID(3).ComboBoxDetails"
                    :label="$t('labels.software')"
                    item-text="selector"
                    :error-messages="softwareErrors"
                    item-value="id" 
                    v-model="Ticket.softwareID")
                v-flex(xs12 sm3)
                  v-select(
                    :items="comboBoxByID(1).ComboBoxDetails"
                    :label="$t('labels.language')"
                    item-text="selector"
                    item-value="id"
                    v-model="Ticket.languageID")
                v-flex(xs12 sm3)
                  v-select(
                    :items="comboBoxByID(2).ComboBoxDetails"
                    :label="$t('labels.priority')"
                    item-text="selector"
                    item-value="id"
                    v-model="Ticket.priorityID")
                v-flex(xs12 sm3)
                  v-select(
                    :items="comboBoxByID(4).ComboBoxDetails"
                    :label="$t('labels.ticketType')"
                    item-text="selector"
                    item-value="id"
                    v-model="Ticket.ticketTypeID")
                v-flex(xs12 sm3)
                  v-select(
                    :items="comboBoxByID(9).ComboBoxDetails"
                    :label="$t('labels.source')"
                    item-text="selector"
                    :error-messages="sourceErrors"
                    item-value="id"
                    v-model="Ticket.sourceID")
                v-flex(xs12 sm3)
                  v-select(
                    :items="comboBoxByID(6).ComboBoxDetails"
                    :label="$t('labels.status')"
                    item-text="selector"
                    item-value="id"
                    v-model="Ticket.statusID")
                v-flex(xs12 sm6)
                  v-autocomplete(v-model="Ticket.assignedToUserID"
                    :items="users"
                    :error-messages="assignedToErrors"
                    item-text='fullName'
                    item-value="userID"
                    :label="$t('labels.assignedTo')")
            v-flex(xs12)
              div Ticket Detail
              v-layout(row wrap) 
                v-flex(xs12)
                  v-text-field(
                  counter
                  :error-messages="titleErrors" v-model="Ticket.title" label='Title*')
                
      v-card-actions
        v-spacer
        v-btn(color='blue darken-1', flat, @click='close()') Close
        v-btn(color='blue darken-1' dark @click='update()') Update
      
</template>

<script>
import locationService from "../../Location/service.js";
import ticketService from "../service.js";
import userService from "../../User/service.js";
import { mapGetters } from "vuex";
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue, email } = require("vuelidate/lib/validators");

export default {
  props: {
    createDialog: {
      default: false
    },
    Ticket: {
      type: Object,
      default: null
    }
  },
  name: "create-ticket",
  data() {
    return {
      storeIsLoading: true,
      dialog: false,
      stores: [],
      users: []
    };
  },
  mixins: [validationMixin],
  validations: {
    Ticket: {
      name: {
        required,
        minLength: minLength(2)
      },
      phoneNumber: {
        required
      },
      email: {
        email
      },
      title: {
        required,
        minLength: minLength(10)
      },
      description: {
        required,
        minLength: minLength(10)
      },
      sourceID: {
        required,
        minValue: minValue(1)
      },
      softwareID: {
        required,
        minValue: minValue(1)
      },
      assignedToUserID: {
        required,
        minValue: minValue(1)
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBox", "comboBoxByID", "currentUser"]),
    contactNameErrors() {
      const errors = [];
      if (!this.$v.Ticket.name.$dirty) return errors;
      if (!this.$v.Ticket.name.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.name.minLength)
        errors.push(this.$t("validations.fieldMustbeatLeast4ChrLong"));
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.Ticket.phoneNumber.$dirty) return errors;
      if (!this.$v.Ticket.phoneNumber.required) errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    emailAddressErrors() {
      const errors = [];
      if (!this.$v.Ticket.email.$dirty) return errors;
      if (!this.$v.Ticket.email.email) errors.push(this.$t("validations.emailIsNotValid"));
      return errors;
    },
    titleErrors() {
      const errors = [];
      if (!this.$v.Ticket.title.$dirty) return errors;
      if (!this.$v.Ticket.title.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.title.minLength) errors.push("Field must be at least 10 characters long");
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.Ticket.description.$dirty) return errors;
      if (!this.$v.Ticket.description.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.description.minLength)
        errors.push("Field must be at least 10 characters long");
      return errors;
    },
    assignedToErrors() {
      const errors = [];
      if (!this.$v.Ticket.assignedToUserID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.assignedToUserID.minValue) errors.push("Pleaes user name");
      return errors;
    },
    sourceErrors() {
      const errors = [];
      if (!this.$v.Ticket.sourceID.$dirty) return errors;
      if (!this.$v.Ticket.sourceID.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.sourceID.minValue) errors.push("Pleaes select source");
      return errors;
    },
    softwareErrors() {
      const errors = [];
      if (!this.$v.Ticket.softwareID.$dirty) return errors;
      if (!this.$v.Ticket.softwareID.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Ticket.softwareID.minValue) errors.push("Pleaes select software");
      return errors;
    }
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
      this.getAllUsers();
    }
  },
  methods: {
    getAllUsers() {
      return userService.getAllCrmUser().then(result => {
        this.users = result.data;
      });
    },
    close() {
      this.$emit("close");
    },
    update() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        let contactStatus = false;
        if (!this.Ticket.phoneNumber) {
          if (!this.Ticket.email) {
            contactStatus = false;
          } else {
            contactStatus = true;
          }
        } else {
          contactStatus = true;
        }
        if (!contactStatus) {
          this.$swal("Ticket", "Please enter contact phone number or email address", "warning");
        } else {
          this.Ticket.loginEmail = this.currentUser.loginEmail;
          delete this.Ticket.dueDate;
          delete this.Ticket.rating;
          return ticketService
            .update(this.Ticket.id, this.Ticket)
            .then(result => {
              if (result.status) {
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000
                  })
                  .fire({
                    type: "success",
                    title: "Ticket was updated"
                  });
                this.$emit("updated");
              }
              console.log("ticket created", result);
            })
            .catch(err => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: err.data.data
                });
              console.log("error creating ticket", err);
            });
        }
      }

      // title: $('#ticketTitle1').val(),
      // ticketTypeID: $("#type option:selected").val(),
      // reporterUserID:#{userData.userID},
      // assignedToUserID:$('#assignedTo').val(),
      // description:$('#description').val(),
      // solution:$('#solution').val(),
      // storeID:#{store.data.storeID},
      // languageID:$("#language option:selected").val(),
      // sourceID:$("#source option:selected").val(),
      // phoneNumber:$('#contactNumber').val(),
      // name:$('#callerName').val(),
      // email:$('#emailAddress').val(),
      // priorityID:$("#priority option:selected").val(),
      // statusID:$("#status option:selected").val(),
      // softwareID:$("#software option:selected").val(),
      // createdAt: new Date().toISOString(),
      // dueDate: new Date().toISOString()
    }
  }
};
</script>

<style scoped></style>
